import React, { forwardRef } from 'react'
import { Eye } from 'react-bootstrap-icons'
import DropdownYesNo from '../Dropdown/DropdownYesNo'
import { yes_no_array } from '../Dummi_Data'
import DropdownDebitCredit from '../Dropdown/DropdownDebitCredit'
import { debit_credit_array } from '../Dummi_Data'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { dateFormateShow } from '../Date_Formate_Utilitiy/Index'

const InputField = forwardRef(({
    type,
    lable,
    name,
    value,
    handleChange,
    handleFocus,
    handleBlur,
    handleMouseFocus,
    handleKeyDown,
    isRequired,
    isDrop,
    show_drop,
    setDrop_add_show,
    data,
    setData,
    refs,
    isDisabled,
    handleDropdownClick,
    height,
    isVertical,
    placeholder }, ref) => {
    const { userData = null } = useSelector(state => state.auth);
    const location = useLocation();
    //console.log(data.combination_of_units);
    if (isVertical) {
        return (
            <div className='m-0 p-0 text-start' style={{ height: height ? height : 'auto' }}>
                <div className='m-0 p-0 mb-1'>
                    <label className={isDisabled ? 'text-muted' : ''}>
                        {lable}{isRequired ? <span className='star_color'>*</span> : null}
                    </label>
                </div>
                <div className='p-0 m-0' style={{ position: 'relative' }}>
                    {name === 'conversion' ? <span style={{ fontSize: 13, fontWeight: 'bold', width: '10%', display: 'inline-flex' }}>of</span> : ''}
                    <input
                        style={{ fontSize: 13, fontWeight: 'bold', width: name === 'conversion' ? '90%' : '100%', display: name === 'conversion' ? 'inline-flex' : 'block' }}
                        type={type}
                        autoComplete="off"
                        disabled={isDisabled}
                        className={isDisabled ? 'text-muted' : ''}
                        autoFocus={name === 'company_name' || name === 'name' || name === 'ledger_name' || name === 'symbol' || name === 'first_unit_id' || name === 'create_date'}
                        name={name}
                        id={name}
                        placeholder={placeholder}
                        value={value || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onFocus={handleFocus}
                        onMouseUp={handleMouseFocus}
                        onKeyDown={handleKeyDown}
                        ref={ref}
                    />
                    {name === 'quantity' ? <p style={{ fontSize: '14px', height: 15, marginTop: -4 }}><label style={{ fontSize: '12px' }}>({data?.combination_of_units})</label></p> : ''}
                </div>
            </div>
        )
    }
    return (
        <div className={`row m-0 p-0 ${name === 'opening_balance' ? `justify-content-end` : ``}`} style={{ height: height ? height : '3.5vh' }}>
            <div className={`${name === 'opening_balance' ? `col-6` : `col-5`} m-0 p-0 text-start ${location.pathname === '/chart-of-account-accounting-master-voucherstype' ? '' : 'text-truncate'}`}>
                <label className={isDisabled ? 'text-muted' : ''} >{lable}{isRequired ? <span className='star_color'>*</span> : null} {name === 'opening_balance' ? `(${dateFormateShow(userData?.books_being_date)})` : null}</label>
            </div>
            <div className={`m-0 p-0`} style={{ width: '2%' }}>
                <label className={isDisabled ? 'text-muted' : ''}>:</label>
            </div>
            <div className={`${name === 'opening_balance' ? `col-5 text-end` : `col-6 text-start`} p-0 m-0`} style={{ position: 'relative' }}>
                <input
                    style={{ textAlign: name === 'opening_balance' ? 'right' : 'left', fontSize: 13, fontWeight: 'bold', width: name === 'opening_balance' ? '105px' : '100%' }}
                    type={type}
                    autoComplete="off"
                    disabled={isDisabled}
                    className={isDisabled ? 'text-muted' : ''}
                    autoFocus={name === 'company_name' || name === 'name' || name === 'ledger_name' || name === 'symbol' || name === 'first_unit_id' || name === 'create_date'}
                    name={name}
                    id={name}
                    placeholder={placeholder}
                    value={value || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                    onMouseUp={handleMouseFocus}
                    onKeyDown={handleKeyDown}
                    ref={ref}
                />
                {
                    name === 'type' ?
                        <DropdownDebitCredit
                            state={show_drop}
                            setState={setDrop_add_show}
                            data={data}
                            setData={setData}
                            input_value={value}
                            input_key={name}
                            rawData={debit_credit_array}
                            ref={ref}
                            refs={refs}
                            handleDropdownClick={handleDropdownClick}
                        // next={next}
                        />
                        : show_drop && (
                            <DropdownYesNo
                                state={show_drop}
                                setState={setDrop_add_show}
                                data={data}
                                setData={setData}
                                input_value={value}
                                input_key={name}
                                rawData={yes_no_array}
                                ref={ref}
                                refs={refs}
                                handleDropdownClick={handleDropdownClick}
                            // next={next}
                            />)
                }
            </div>
        </div>
    )
})

export default React.memo(InputField)